<div class="info-page">
  <h3>Editar Projeto Agregador</h3>
</div>

<form [formGroup]="form" (ngSubmit)="salvar()">
  <div class="form-group row m-b">
    <div class="col-sm-8">
      <label class="col-sm-12 pb-1">Projeto:</label>
      <textarea id="title" class="form-control" rows="3" formControlName="title"></textarea>
      <app-field-message [field]="fieldMessageRequired('title')" [erros]="fieldErros('title')"></app-field-message>
    </div>
  </div>

  <div class="form-group row m-b">
    <div class="col-sm-8">
      <label class="col-sm-12 pb-1">Descrição:</label>
      <textarea id="description" class="form-control" rows="3" formControlName="description"></textarea>
      <app-field-message [field]="fieldMessageRequired('description')"
        [erros]="fieldErros('descricao')"></app-field-message>
    </div>
  </div>

  <div class="form-group row m-b">
    <div class="col-sm-10 col-xl-6">
      <label class="col-sm-12 pb-1">Órgão responsável</label>
      <ng-select id="agency" class="ng-select-alternative" [items]="orgaoList" bindLabel="str_nome"
        bindValue="num_codigo_pk" placeholder="Selecione o Órgão" formControlName="agency_id">
      </ng-select>
      <app-field-message [field]="fieldMessageRequired('agency_id')"
        [erros]="fieldErros('agency_id')"></app-field-message>
    </div>
  </div>

  <div class="form-group row m-b">
    <div class="col-sm-10 col-xl-6">
      <label class="col-sm-12 pb-1">Gerente </label>
      <ng-select id="manager_cpf" class="ng-select-alternative" [items]="usuarioList" bindLabel="label" bindValue="id"
        placeholder="Selecione o Gerente" formControlName="manager_cpf">
      </ng-select>
      <app-field-message [field]="fieldMessageRequired('manager_cpf')"
        [erros]="fieldErros('manager_cpf')"></app-field-message>
    </div>
  </div>

  <div formArrayName="manager_adjunct">
    <div class="form-group row m-b" *ngFor="let item of getFormArray().controls; let i = index">
      <div class="col-sm-6">
        <label class="col-sm-12 pb-1">Gerente Adjunto</label>
        <ng-select id="manager" class="ng-select-alternative" [items]="usuarioList" bindLabel="label" bindValue="id"
          placeholder="Selecione o Gerente Adjunto" [formControlName]="i">
        </ng-select>
      </div>
      <button class="btn btn-danger col-sm-1 btn-remove" type="button" (click)="removeAdjunctManager(i)"><i
          class="fa fas fa-times"></i></button>
    </div>
  </div>
  <button class="btn btn-success btn-add-item" type="button" (click)="addNewAdjunctManager()">Novo Responsável
    Adjunto</button>

  <div class="form-group row m-b">
    <div class="col-sm-10 col-xl-6">
      <label class="col-sm-12 pb-1">Ativo</label>
      <ng-select id="actived" class="ng-select-alternative" [items]="values_actived" bindLabel="label" bindValue="id"
        placeholder="Selecione" formControlName="actived"></ng-select>
      <app-field-message [field]="fieldMessageRequired('actived')" [erros]="fieldErros('actived')"></app-field-message>
    </div>
  </div>

  <div class="form-group row m-b">
    <div class="col-sm-10 col-xl-6">
      <label class="col-sm-12 pb-1">Programa/Projeto agregador Pai</label>
      <ng-select id="pg_id" class="ng-select-alternative" [items]="programaPaiList" bindLabel="label" bindValue="id"
        placeholder="Selecione o programa pai" formControlName="pg_id">
      </ng-select>
      <app-field-message [field]="fieldMessageRequired('pg_id')" [erros]="fieldErros('pg_id')"></app-field-message>
    </div>
  </div>

  <div class="hr-line-dashed"></div>
  <div class="form-group row d-flex justify-content-end">
    <div class="col-sm-8 col-sm-offset-2 d-flex justify-content-end">
      <button class="btn btn-danger m-r-xs btn-excluir" *ngIf="this.projeto.permissions?.delete"
        (click)="confirmExcluir()" type="button">Excluir</button>
      <button class="btn btn-white m-r-xs" type="button" (click)="voltar()">Voltar</button>
      <button class="btn btn-primary" type="submit">Salvar</button>
    </div>
  </div>
</form>
<br>
<app-historico-atualizacoes-list [audit]="audit"></app-historico-atualizacoes-list>
<app-loading [loader]="isLoading"></app-loading>
